import React, { useState } from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';
import {
    USAMapBubbleChart,
    HighchartBarChart,
    CustomButtonGroup,
    USACountryChart,
} from '../../../shared';
import { DISTRIBUTION_CHART_OPTIONS, USA_CHART_OPTIONS, mapOptions } from './constants';
import { BREAKDOWN, REGENERON_COMPANY_ID, XEVINAPANT_COMPANY_ID,  } from '../../../../constants';

const MemoizedUSAMapBubbleChart = React.memo(USAMapBubbleChart);

function DistrictBreakdown() {
    const [selectedBreakdown, setSelectedBreakdown] = useState(BREAKDOWN[0]);
    const { company } = useSelector((state) => state.company);
    const { triggerSummary
    } = useSelector((state) => state.trigger);
    const {
        overallPhysicians, 
        stateOverallPhysicians,
        isTriggerSummaryGraphsLoading, 
        distributionRegion, 
        districtBreakdownUSAMapData, 
        stateDistributionRegion,
        stateBreakdownUSAMapData,
        stateMapSeries,
    } = triggerSummary;
    const handleDistrictBreakdown = (option) => {
        setSelectedBreakdown(option);
    };

    const handleCustomisation = () => {
        let companyId = company.id, chartSeries = [], breakdown = '';

        if(companyId && (companyId === XEVINAPANT_COMPANY_ID || companyId === REGENERON_COMPANY_ID)){
            chartSeries = stateDistributionRegion;
            breakdown = 'State';
        } else if(selectedBreakdown === BREAKDOWN[1]){
            chartSeries = stateDistributionRegion;
            breakdown = 'State';
        } else {
            chartSeries = distributionRegion;
            breakdown = 'District';
        }

        return { chartSeries, breakdown };
    };

    return (
        <Box className="box-sizing-border-box padding-24px">
            <Box className="padding-tb-20 border-bottom-gray flex-row-space-between-center">
                <Box>
                    <Typography className="text-lg-semi-bold gray-900">
                        {handleCustomisation().breakdown} Breakdown of Triggered Physicians
                    </Typography>
                </Box>
                {
                    !(company.id === XEVINAPANT_COMPANY_ID || company.id === REGENERON_COMPANY_ID) 
                    ?   (<Box>
                            <CustomButtonGroup
                                key="breakdown"
                                data={BREAKDOWN}
                                selected={selectedBreakdown}
                                handleClick={(option) => handleDistrictBreakdown(option)}
                            />
                        </Box>)
                    : null 
                }
            </Box>

            <Grid container className="flex-row-center">
                <Grid item lg={7} xl={8} className="us-bubble-map-container">
                    {/* Location Chart */}
                    {
                        isTriggerSummaryGraphsLoading
                        ?   <Skeleton variant="rectangular" width='95%' height={300}/> 
                        :   selectedBreakdown === BREAKDOWN[0] 
                                ?   <MemoizedUSAMapBubbleChart 
                                        chartOptions={mapOptions} 
                                        seriesData={
                                            (company.id === XEVINAPANT_COMPANY_ID || company.id === REGENERON_COMPANY_ID) 
                                            ?   stateBreakdownUSAMapData 
                                            :   districtBreakdownUSAMapData
                                        }
                                    />
                                :   <USACountryChart
                                        chartOptions={USA_CHART_OPTIONS}
                                        mapSeries={stateMapSeries}
                                    />
                    }
                </Grid>

                <Grid
                    item
                    lg={5}
                    xl={4}
                >
                    <Box className="container-p-24-br-16 bg-gray-50 mt-24px">
                        {/* Location Info */}
                        <Box className="flex-column gap-4">
                            <Typography className="text-lg-semi-bold gray-900">
                                {handleCustomisation().breakdown} Breakdown of Triggered Physicians
                            </Typography>
                            <Typography className="text-sm-regular gray-500">
                                {
                                    isTriggerSummaryGraphsLoading 
                                    ? <Skeleton variant='text' width={100}/> 
                                    : (company.id === XEVINAPANT_COMPANY_ID || company.id === REGENERON_COMPANY_ID)  
                                        ? stateOverallPhysicians
                                        : overallPhysicians
                                } Overall Physicians
                            </Typography>
                        </Box>
                        <Box className="pt-24px district-breakdown-bar-chart">
                            {isTriggerSummaryGraphsLoading ? <Skeleton variant="rectangular" width='100%' height={300} /> :
                                <HighchartBarChart 
                                    key={`chart-${selectedBreakdown}-${company.id}`}
                                    chartOptions={{
                                        ...DISTRIBUTION_CHART_OPTIONS,
                                        chart: {
                                            ...DISTRIBUTION_CHART_OPTIONS.chart,
                                            height: ((company.id === XEVINAPANT_COMPANY_ID || company.id === REGENERON_COMPANY_ID) || BREAKDOWN[1] === selectedBreakdown) 
                                                ? (stateDistributionRegion.length > 0 
                                                    ? stateDistributionRegion.length * 35
                                                    : 0)
                                                : (distributionRegion.length > 0 
                                                    ? distributionRegion.length * 35 
                                                    : 0),
                                        },
                                    }}
                                    seriesData={handleCustomisation().chartSeries} 
                                    seriesName="Digital Engagement" 
                                />
                            }
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    )
}

export default DistrictBreakdown